


























































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
  PropSync,
  Emit,
} from 'vue-property-decorator'
import HdsCard from '@/components/HdsCard.vue'
import HdsList from '@/components/HdsList.vue'
import HdsListItem from '@/components/HdsListItem.vue'
import HdsIcon from '@/components/HdsIcon.vue'
import HdsBtn from '@/components/HdsBtn.vue'
import HdsChip from '@/components/HdsChip.vue'
import HdsTextField from '@/components/HdsTextField.vue'
import Draggable from 'vuedraggable'

export const DROPDOWN_DIRECTION = {
  RELATIVE: {
    DOWN: 'rd',
    RIGHT: 'rr',
  },
  ABSOLUTE: {
    DOWN: 'ad',
    RIGHT: 'ar',
  },
}

/**
 * 드롭 다운 메뉴나, Select에서 쓰입니다. nested 사용가능합니다.
 */
@Component({
  components: {
    HdsTextField,
    HdsChip,
    HdsDropdown: () => import('./HdsDropdown.vue'),
    HdsCard,
    HdsList,
    HdsListItem,
    HdsIcon,
    HdsBtn,
    Draggable,
  },
})
export default class HdsDropdown extends Vue {
  on = false
  childOn = false
  updateTarget: any = ''
  updateBackup: any = ''
  drag: boolean = false

  created() {
    document.addEventListener('keydown', this.onKeydown, true)
    document.addEventListener('keypress', this.onKeypress, true)
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown, true)
    document.removeEventListener('keypress', this.onKeypress, true)
  }

  get dragOptions() {
    return {
      animation: 300,
      handle: '.cursor-move',
      group: 'items',
      disabled: !this.allowSort,
      ghostClass: 'ghost',
      sort: this.allowSort,
    }
  }

  get cardStyles() {
    return {
      width: this.width,
      height: this.height,
      maxHeight: this.maxHeight,
    }
  }

  get isSelected() {
    return (item: any) => this.parsedSelectedItemsSync.find(i => i === item)
  }

  get itemsIncludes() {
    return (text: string) => {
      return this.filteredItemsSync.some(e => e[this.itemText] === text)
    }
  }

  get selectedItemsIncludes() {
    return (text: string) => {
      return this.parsedSelectedItemsSync.some(e => e[this.itemText] === text)
    }
  }

  @Watch('delayedOnSync', { immediate: true })
  onChangeDelayedOn() {
    if (this.delayedOnSync)
      setTimeout(() => {
        if (this.delayedOnSync) this.on = true
      }, this.delayOnTime)

    if (!this.delayedOnSync)
      setTimeout(() => {
        if (!this.delayedOnSync) this.on = false
      }, this.delayOffTime)
  }

  onStartDrag() {
    this.drag = true
  }

  onEndDrag() {
    this.drag = false
  }

  toggleDropdown(bool: boolean) {
    if (this.onlyFocus) return

    this.delayedOnSync = bool
  }

  forceToggleDropdown(bool?: boolean) {
    if (bool !== undefined) this.delayedOnSync = bool
    else this.delayedOnSync = !this.delayedOnSync
  }

  onClick(evt: Event & any, item: any, index: number) {
    evt.value = item
    this.highlightedIndexSync = index
    this.$emit('click', evt)
  }

  onMousedown(evt: Event) {
    this.$emit('mousedown', evt)
  }

  onKeydown(evt: KeyboardEvent) {
    if (!this.on) return
    this.$emit('keydown', evt)
  }

  onKeypress(evt: KeyboardEvent) {
    if (!this.on) return
    this.$emit('keypress', evt)
  }

  @Emit('clickCreateBtn') onClickCreateBtn(evt: Event) {
    return evt
  }

  onClickUpdateBtn(evt: Event, item: any, index: number) {
    this.updateTarget = item
    this.updateBackup = JSON.parse(JSON.stringify(item[this.itemText]))
    this.$nextTick(() => {
      ;(this.$refs.input as HdsTextField[])[index].focus()
    })
  }

  onClickUpdateDoneBtn(evt: Event, value: any) {
    this.parsedSelectedItemsSync = this.parsedSelectedItemsSync.map(v =>
      v === this.updateBackup ? value : v,
    )
    this.parsedItemsSync = this.parsedItemsSync.map(v =>
      v === this.updateBackup ? value : v,
    )
    this.updateTarget = null
    this.updateBackup = null
  }

  onClickUpdateCancelBtn() {
    this.updateTarget[this.itemText] = this.updateBackup
    this.updateBackup = null
    this.updateTarget = null
  }

  onClickDeleteBtn(evt: Event, value: any) {
    if (!this.allowDelete) return
    this.parsedSelectedItemsSync = this.parsedSelectedItemsSync.filter(
      v => v !== value,
    )
    this.parsedItemsSync = this.parsedItemsSync.filter(v => v !== value)
  }

  @PropSync('highlightedIndex') highlightedIndexSync!: null | number

  @PropSync('delayedOn', { type: Boolean, default: false })
  delayedOnSync!: boolean

  @PropSync('items', { type: Array, default: () => [] })
  itemsSync!: any[]

  @PropSync('parsedItems', { type: Array, default: () => [] })
  parsedItemsSync!: any[]

  @PropSync('filteredItems', { type: Array, default: () => [] })
  filteredItemsSync!: any[]

  @PropSync('parsedSelectedItems', { type: Array, default: () => [] })
  parsedSelectedItemsSync!: any[]

  @PropSync('value', { type: String, default: '' })
  valueSync!: string

  @Prop({ type: Boolean, default: false })
  checkbox!: boolean

  /**
   * 아이템이 오브젝트일때,
   * 아이템 text 키.
   */
  @Prop({ type: String, default: 'text' })
  itemText!: string

  /**
   * 아이템이 오브젝트일때,
   * 아이템 value 키.
   */
  @Prop({ type: String, default: 'value' })
  itemValue!: string

  /**
   * 아이템이 오브젝트일때,
   * 아이템의 sub array 키.
   */
  @Prop({ type: String, default: 'array' })
  itemArray!: string

  /**
   * 드롭 다운이 열리는 딜레이 ms
   */
  @Prop({ type: Number, default: 50 })
  delayOnTime!: number

  /**
   * 드롭 다운이 닫히는 딜레이 ms
   */
  @Prop({ type: Number, default: 100 })
  delayOffTime!: number

  /**
   * 너비를 지정합니다.
   */
  @Prop({ type: String })
  width?: string

  /**
   * 높이를 지정합니다.
   */
  @Prop({ type: String, default: 'auto' })
  height!: string

  /**
   * 최대 높이를 지정합니다.
   */
  @Prop({ type: String, default: 'auto' })
  maxHeight!: string

  /**
   * 방향
   */
  @Prop({ type: String, default: DROPDOWN_DIRECTION.RELATIVE.DOWN })
  direction!: string

  /**
   * Empty text
   */
  @Prop({ type: String, default: 'Empty' })
  textEmpty!: string

  /**
   * Create text
   */
  @Prop({ type: String, default: 'Press enter to create.' })
  textCreate!: string

  /**
   * 포커스에서만 드롭다운이 열립니다.
   */
  @Prop({ type: Boolean, default: false })
  onlyFocus!: boolean

  /**
   * **커스텀 옵션**: 콤보박스처럼 옵션을 추가
   */
  @Prop({ type: Boolean, default: false })
  allowCreate!: boolean

  /**
   * **커스텀 옵션**: 콤보박스처럼 옵션을 수정
   */
  @Prop({ type: Boolean, default: false })
  allowUpdate!: boolean

  /**
   * **커스텀 옵션**: 콤보박스처럼 옵션을 삭제
   */
  @Prop({ type: Boolean, default: false })
  allowDelete!: boolean

  /**
   * 드래그 앤 드롭으로 정렬 가능
   */
  @Prop({ type: Boolean, default: false })
  allowSort!: boolean

  /**
   * limit item text length
   */
  @Prop({ type: Number, default: 0 }) maxLength!: number

  /**
   * 선택된 아이템 숨김
   */
  @Prop({ type: Boolean, default: false }) hideSelected!: boolean
}
